import Api from '@/services/Api'

export default {
    leaPaises(estado){
        return Api().get('NleaPaises/'+estado)
    },
    leaEstadosSeg(estado){
        return Api().get('leaEstadosSeg/'+estado)
    },
    leaNovedades(pais,factura,identificacion){
        return Api().get('leaNovedades/'+pais+'/'+identificacion+'/'+factura)
    },
    grabeNovedades(estado,u_modifica,listNovedades){
        return Api().put('grabeNovedades/'+estado+'/'+u_modifica,listNovedades)
    },

    leaFacturas(pais,opcion,data){
        return Api().put('NleaFacturas/'+pais+'/'+opcion,data)
    },

    leaInformacionNovedades(pais,desde,hasta,opcion){
        return Api().get('leaInformacionNovedades/'+pais+'/'+desde+'/'+hasta+'/'+opcion)
    },
    leaInformacionMetricas(pais,desde,hasta,opcion){
        return Api().get('leaInformacionMetricas/'+pais+'/'+desde+'/'+hasta+'/'+opcion)
    },
    leaInformacionReporte(pais,desde,hasta){
        return Api().get('leaInformacionReporte/'+pais+'/'+desde+'/'+hasta)
    },
    leaInformacionRepNovedades(pais,desde,hasta,todos){
        return Api().get('leaInformacionRepNovedades/'+pais+'/'+desde+'/'+hasta+'/'+todos)
    },
}
